import { useEffect } from 'react';
import { useWatch, type Control } from 'react-hook-form';

import { registryStore, type Registry } from '@/stores/registry';

export const useZustandSync = <T>(
  control: Control<any>,
  mapper: (formData: T, registry: Registry) => Partial<Registry>
) => {
  const values = useWatch({ control });

  useEffect(() => {
    const mappedValues = mapper(values, registryStore.getState().registry);
    registryStore.getState().setFields(mappedValues);
  }, [values, mapper]);
};
